import React from 'react';
import { FaClipboardList, FaCheckCircle, FaBan, FaClock } from 'react-icons/fa';
import { SmallStatPill } from '../Pills/PillsV2';
import { getProjectSummary } from '../../projectView';
import './ProjectSummary.css';

export default function ProjectSummary({ rows, onShowNoAccess }) {
  const counts = getProjectSummary(rows);
  return <div className="pills-container" aria-label="Project summary">
    <div className="project-summary-grid">
      <SmallStatPill title="Project entries" titleClass="pill-title-total"
        icon={<FaClipboardList />} iconColor="#2563eb" value={counts.total}
        label="project entries" />
      <SmallStatPill title="Completed" icon={<FaCheckCircle />} iconColor="#16a34a"
        value={counts.Completed} valueColor="#16a34a" label="entries completed" />
      <SmallStatPill title="No Access" titleClass="pill-title-found" icon={<FaBan />}
        iconClass="pill-icon-missed" value={counts['No Access']} valueColor="#d97706"
        cta={onShowNoAccess ? { label: 'See All No Access Units', onClick: onShowNoAccess } : null} />
      {counts.Pending > 0 && <SmallStatPill title="Pending" icon={<FaClock />}
        iconColor="#64748b" value={counts.Pending} valueColor="#64748b" label="entries pending" />}
    </div>
  </div>;
}
